import React from 'react'
import PropTypes from 'prop-types'
import SidebarView from './Sidebar.view.jsx'
import { useSidebarLogic } from './Sidebar.logic.js'

const Sidebar = ({ isLane }) => {
  const { returnUrl } = useSidebarLogic()

  return <SidebarView isLane={isLane} returnUrl={returnUrl} />
}

Sidebar.propTypes = {
  isLane: PropTypes.bool,
}

export default Sidebar
